import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export class CreateClientProfileReqData {
    name: string;
    organizationId: number;
    windowsGroup: string;
    authPluginGroup: string;
    privileges: ClientPrivileges;
    associatedFoldersIds: number[];
}
